import { render, staticRenderFns } from "./pages4.vue?vue&type=template&id=6300902c&scoped=true&"
import script from "./pages4.vue?vue&type=script&lang=js&"
export * from "./pages4.vue?vue&type=script&lang=js&"
import style0 from "./pages4.vue?vue&type=style&index=0&id=6300902c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6300902c",
  null
  
)

export default component.exports